import { Button, Table } from "react-bootstrap"
import { GlgLoadingSpinner } from 'SharedComponents';
import React, { useState, useEffect } from "react"
import { useGetCoursesQuery } from "../api/courses"
import { coursesApi } from '../api/courses';
import { Course } from "./course";
import { useDispatch, useSelector } from "react-redux";
import { setCourseCount, setPage } from "../store/miscSlice";

const PAGE_SIZE = 20;

export const CourseTable = () => {
  const prefetchCourses = coursesApi.usePrefetch('getCourses');

  const filters = useSelector(state => state.filters)
  const renderedPages = useSelector(state => state.misc.data.renderedPages)
  const requestedPages = useSelector(state => state.misc.data.requestedPages)
  const canManageCourse = useSelector(state => state.misc.data.canManageCourse)
  const isTeamCaptain = useSelector(state => state.misc.data.isTeamCaptain)

  const dispatch = useDispatch()

  const { 
    data,
    isLoading, 
    isFetching,
    error,
  } = useGetCoursesQuery({ page: renderedPages, filters: filters })

  const allCourses = data?.courses
  const courses = allCourses?.slice(0, renderedPages * PAGE_SIZE)

  useEffect(() => {
    if (allCourses && !isFetching) {
      const hasFullCurrentPage = allCourses.length >= renderedPages * PAGE_SIZE;
      const nextPageAlreadyCached = allCourses.length > renderedPages * PAGE_SIZE;
      if (hasFullCurrentPage && !nextPageAlreadyCached) {
        prefetchCourses(
          { page: renderedPages + 1, filters },
          { force: true, subscription: false }
        );
      }
    }
  }, [allCourses?.length, isFetching, renderedPages, prefetchCourses, filters]);

  useEffect(() => {
    dispatch(setCourseCount(data?.count))
  }, [data?.count])

  const handleLoadMore = () => {
    dispatch(setPage(renderedPages + 1))
  };
  
  if (isLoading && !courses) 
    return( 
      <div className="courses-spinner-container">
        <GlgLoadingSpinner/>
      </div>);
    
  const isFetchingMore = isFetching && requestedPages > renderedPages;
  
  const showLoadMore = (courses?.length ?? 0) >= renderedPages * PAGE_SIZE && !isFetchingMore

  const LoadMoreButton = () => {
    if(isFetching){
      return(
        <div className="justify-center">
          <Button 
            onClick={handleLoadMore} 
            disabled={isFetching}
            variant="secondary"
          >
            {window.I18n.t('courses.loading_next_page')}
          </Button>
        </div>
      )
    }
    else if(showLoadMore) {
      return(
        <div className="justify-center">
          <Button 
            onClick={handleLoadMore} 
            disabled={isFetchingMore}
            variant="secondary"
          >
            {window.I18n.t('courses.load_more')}
          </Button>
      </div>
      )
    }
    else {
      return(<div className="justify-center">{window.I18n.t('courses.all_courses_loaded')}</div>)
    }
  }

  return(
    <>
      <Table striped bordered hover responsive className="tables_v2">
        <thead>
          <tr>
            <th className="check_col"></th>
            <th>{window.I18n.t('courses.bootstrap_course_table_data.name')}</th>
            <th>{window.I18n.t('courses.bootstrap_course_table_data.location')}</th>
            {!gon.uses_non_whs_terminology && <th>{window.I18n.t('courses.compliance_status')}</th>}
            <th>{window.I18n.t('courses.bootstrap_course_table_data.course_abbreviation')}</th>
            {canManageCourse && !isTeamCaptain && <th>{window.I18n.t('courses.bootstrap_course_table_data.actions')}</th>}
          </tr>
        </thead>
        <tbody>
          {courses?.length > 0 ? (
            courses.map((course) => (
              <Course key={course.id} course={course} />
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center py-4 white-bg">
                {window.I18n.t('courses.no_courses_found')}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <LoadMoreButton/>
    </>
  )
}
